import { Expression } from 'api/hulkApi'

// Shared Hulk filter predicates for sales_estimates text search, used by both
// the widget query and the typeahead lookups so they stay in sync.

// `brand_searchable` is normalized so some queries miss; OR with the raw
// `brand_stable` to catch those. Hulk resolves `_contains` to a case-insensitive
// ilike.
export const buildBrandSearchPredicate = (
    query: string | undefined
): Expression | undefined =>
    query
        ? {
              _or: [
                  {
                      field: 'brand_searchable',
                      operator: '_contains',
                      value: query,
                  },
                  {
                      field: 'brand_stable',
                      operator: '_contains',
                      value: query,
                  },
              ],
          }
        : undefined

// ASIN values are stored uppercase, so uppercase the input to keep the prefix
// match case-insensitive.
export const buildAsinSearchPredicate = (
    query: string | undefined
): Expression | undefined =>
    query
        ? {
              field: 'asin',
              operator: '_starts_with',
              value: query.toUpperCase(),
          }
        : undefined
